/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { CoreModelKey } from '../key/core-model.key';
import { ApplicationError } from '../model/application-error.model';
import { ValidationError } from '../model/validation-error.model';
import { MessageFactory, MessageFactoryProvider } from '../provider/message-factory.provider';
import { TextService } from '../service/text.service';

export class FieldValidationErrorMessageFactory implements MessageFactory {

  constructor(private textService: TextService) { }

  getMessage(error: ApplicationError): string {
    const textKey = error.key;
    const errorArguments: { [key: string]: any } = error.arguments;
    let field: string;
    if (!errorArguments.key) {
      field = '#(kit-core/name/field)';
    } else if (!errorArguments.scope) {
      field = errorArguments.key;
    } else {
      field = `#(${errorArguments.scope}/${errorArguments.key})`;
    }
    const errors: string = this.getErrorMessage(errorArguments.errors);
    const textArgs = Object.assign({}, errorArguments, { field, errors });
    return this.textService.getText(textKey, textArgs);
  }

  getErrorMessage(errors: ValidationError[]): string {
    const validationErrorMessageFactory = MessageFactoryProvider.resolveMessageFactory(CoreModelKey.VALIDATION_ERROR);
    const validationErrorMessages: string[] = errors.map((validationError: ValidationError) => {
      return validationErrorMessageFactory
        ? validationErrorMessageFactory.getMessage(validationError)
        : JSON.stringify(validationError);
    });
    return validationErrorMessages.join('; ');
  }

}
